import { UtensilsCrossed, Book, Scale, Heart, Cake, ExternalLink, Salad, Pizza } from "lucide-react";

const FOOD_LINKS = [
  { name: "AllRecipes", icon: Book, url: "https://www.allrecipes.com", color: "bg-orange-600" },
  { name: "Food Network", icon: UtensilsCrossed, url: "https://www.foodnetwork.com", color: "bg-red-600" },
  { name: "Epicurious", icon: Book, url: "https://www.epicurious.com", color: "bg-yellow-600" },
  { name: "Tasty", icon: UtensilsCrossed, url: "https://tasty.co", color: "bg-pink-600" },
  { name: "Yummly", icon: Book, url: "https://www.yummly.com", color: "bg-orange-500" },
  { name: "Yelp", icon: Pizza, url: "https://www.yelp.com", color: "bg-red-500" },
  { name: "OpenTable", icon: UtensilsCrossed, url: "https://www.opentable.com", color: "bg-red-700" },
  { name: "DoorDash", icon: Pizza, url: "https://www.doordash.com", color: "bg-red-600" },
  { name: "Healthy Recipes", icon: Salad, url: "https://www.eatingwell.com", color: "bg-green-600" },
  { name: "Cooking Light", icon: Heart, url: "https://www.cookinglight.com", color: "bg-green-500" },
  { name: "Dessert Recipes", icon: Cake, url: "https://www.delish.com/cooking/recipe-ideas/g2680/easy-dessert-recipes/", color: "bg-pink-500" },
  { name: "Baking Recipes", icon: Cake, url: "https://sallysbakingaddiction.com", color: "bg-amber-600" },
  { name: "Measurements", icon: Scale, url: "https://www.traditionaloven.com/culinary-arts/cooking/", color: "bg-gray-600" },
  { name: "Unit Converter", icon: Scale, url: "https://www.convertunits.com/from/cups/to/ml", color: "bg-blue-600" },
];

const FoodCookingPanel = ({ roomId }) => {
  if (roomId !== "food-cooking") return null;

  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="retro-window mb-2" data-testid="food-cooking-panel">
      <div className="retro-title-bar px-2 py-1">
        <span className="flex items-center gap-1">
          <UtensilsCrossed className="w-4 h-4" />
          🍳 FOOD & RECIPES
        </span>
      </div>

      <div className="p-2 bg-gradient-to-b from-orange-50 to-yellow-50 max-h-[300px] overflow-y-auto retro-scrollbar">
        <div className="space-y-1">
          {FOOD_LINKS.map((link, index) => {
            const Icon = link.icon;
            return (
              <button
                key={index}
                className={`${link.color} hover:opacity-90 text-white rounded w-full p-1.5 transition-all flex items-center gap-2 text-xs`}
                onClick={() => openLink(link.url)}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="font-bold truncate">{link.name}</span>
                <ExternalLink className="w-3 h-3 ml-auto flex-shrink-0 opacity-70" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FoodCookingPanel;
